<svg *ngIf="!model" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#607675" class="bi bi-square"
    viewBox="0 0 16 16" (click)="toggleValue()">
    <path
        d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1h12zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2z" />
</svg>

<svg *ngIf="model" xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#607675"
    class="bi bi-check-square-fill" viewBox="0 0 16 16" (click)="toggleValue()">
    <path
        d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2H2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
</svg>